var _defs, _line, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1110({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 0.66,
    x2: 8,
    y2: 15.34
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 4.88,
    r: 4.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1110);
export default __webpack_public_path__ + "static/media/Symbolpack_1_110.ef183bf26aeff289de6057906053749a.svg";
export { ForwardRef as ReactComponent };